import React from 'react';
import { useLocation, useNavigate, useParams } from "react-router-dom";
export function withRouter(Component) {
  return function ComponentWithRouter(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    // Create a history object compatible with v5
    const history = {
      push: (path) => navigate(path),
      goBack: () => navigate(-1),
      location: location,
    };
    return (
      <Component
        {...props}
        location={location}
        navigate={navigate}
        params={params}
        history={history}
      />
    );
  };
}
